// extracted by mini-css-extract-plugin
module.exports = {"defaultContainer":"CryptoIncome_defaultContainer__1nyek"};